import axios from "axios";
import {toast} from "react-toastify";


const RedirectTenantLogin = ()=>{

    // const navigate = useNavigate();
    localStorage.removeItem("TENANT_NAME");
    localStorage.removeItem("TENANT_USER_ID");
    localStorage.removeItem('TREXO_TENANT_AUTH_TOKEN');
    localStorage.removeItem("tenant_username");
    localStorage.removeItem("TENANT_USER_MAIL");
    localStorage.removeItem("TENANT_ROLE");
    localStorage.removeItem("ICON");
    sessionStorage.removeItem('sessionId');
    // navigate("/login");
    window.location.href="/login";
}

const RedirectSuperAdminLogin = ()=>{
    // const navigate = useNavigate();

    localStorage.removeItem("TREXO_AUTH_TOKEN");
    localStorage.removeItem("superadmin_username");
    localStorage.removeItem("SUPERADMIN_USER_MAIL");
   
    // navigate("/superAdmin/login");
    window.location.href="/superAdmin/login";
}

const axios_public = axios.create({
   baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {'Access-Control-Allow-Origin': '*', "Access-Control-Allow-Methods":"GET,PUT,POST,DELETE,PATCH,OPTIONS"},
    withCredentials: true
});

axios_public.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (axios.isCancel(error)) return Promise.reject(error);
      if (error?.config?.silent) return Promise.reject(error);
      if (error?.response?.data?.message){
        toast.error(error.response.data.message);
      }
      else if (error?.message){
        toast.error(error.message);
      }
      else {
        toast.error("Something went wrong");
      }
      return Promise.reject(error);
    }
  );

const axios_superadmin = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL
  });

  axios_superadmin.interceptors.request.use(
    config => {
      if (!config.headers.Authorization) {
        const token = localStorage.getItem('TREXO_AUTH_TOKEN');
  
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
  
      return config;
    },
    error => Promise.reject(error)
  );

  const axios_tenant = axios.create({
      baseURL: `${process.env.REACT_APP_API_BASE_URL}/tenantApi`,
      withCredentials: true
  });

  axios_tenant.interceptors.request.use(
    config => {
      if (!config.headers.Authorization) {
        const token = localStorage.getItem('TREXO_TENANT_AUTH_TOKEN');
        const sessionId = sessionStorage.getItem("sessionId");

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;

          if (sessionId){
            config.headers.Authorization = `Bearer ${token} ${sessionId}`
          }
        }
      }
  
      return config;
    },
    error => Promise.reject(error)
  );

  axios_superadmin.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
      if (axios.isCancel(error)) return Promise.reject(error);
      if (error?.config?.silent) return Promise.reject(error);
      // Handle other error cases here
      if (error?.response?.data?.message){

        if (error.response.status===401){
          RedirectSuperAdminLogin();
        }
        else{
          toast.error(error.response.data.message);
        } 
    }
    else if (error?.message){
      toast.error(error.message);
    }
    else {
      toast.error("Something went wrong");
    }
    return Promise.reject(error);
    }
  );

  axios_tenant.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (axios.isCancel(error)) return Promise.reject(error);
      if (error?.config?.silent) return Promise.reject(error);
      if (!error.response) {
        return Promise.reject(error);
      }

      const errorUrl = error?.response?.config?.url
      const isTrexoChat = errorUrl?.includes("/trexo-assistant/getChatResponse");
      const isTrexoChatOA = errorUrl?.includes("/trexo-assistant/oa/downloadDocuments");
      if((isTrexoChat && error?.response?.status===400) || isTrexoChatOA){
        toast.dismiss();
      } else {
      if (error?.response?.status===401){
        // toast.error("Session expired, please login again");
          RedirectTenantLogin();
        }
        const res = error?.response;

        if (res?.data instanceof Blob) {
          // Return a promise to handle blob asynchronously
          return res.data.text().then((text) => {
            let errorMessage = 'Something went wrong';
            try {
              const json = JSON.parse(text);
              errorMessage = json.message || errorMessage;
            } catch {
              errorMessage = text; // plain text fallback
            }

            toast.error(errorMessage);
            return Promise.reject(error);
          });
        }

        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        } else if (error?.response?.data?.error) {
            toast.error(error.response.data.error);
        } else if (error?.message){
            toast.error(error.message);
        }
        else {
            toast.error("Something went wrong");
        }
      }

        return Promise.reject(error);
    }
  );

  export { axios_public,axios_superadmin, axios_tenant, RedirectTenantLogin };